const VIMEO_REGEX =
    /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/

const YOUTUBE_REGEX =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/

function isVimeoUrl(url: string): boolean {
    return !!url.match(VIMEO_REGEX)
}

function isYouTubeUrl(url: string): boolean {
    return !!url.match(YOUTUBE_REGEX)
}

export function vimeoIdFromUrl(url: string): string | undefined {
    const match = url.match(VIMEO_REGEX)
    return match && match.length > 4 ? match[4] : undefined
}

export function youtubeIdFromUrl(url: string): string | undefined {
    const match = url.match(YOUTUBE_REGEX)
    return match && match.length > 1 ? match[1] : undefined
}

export function fileExtensionFromUrl(url: string): string {
    if (isVimeoUrl(url)) {
        return 'vimeo'
    }

    if (isYouTubeUrl(url)) {
        return 'youtube'
    }

    if (url.indexOf('imaging.giphy.com') > -1) {
        if (url.indexOf('fmt=mp4') > -1) {
            return '.mp4'
        }
        return '.gif'
    }

    return `.${url.split('?')[0].split('.').pop()}`
}
